// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getSimulationEnvironmentTypes } from "../../../api";

export const useSimulationEnvironmentTypes = () => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<string>>({
    queryKey: ["simulation-environment-types"],
    queryFn: async () => {
      const token = await getToken();
      return getSimulationEnvironmentTypes(token);
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
